import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-customer-lookup',
  templateUrl: './customer-lookup.component.html',
  styleUrls: ['./customer-lookup.component.scss'],
  standalone: false
})
export class CustomerLookupComponent implements OnInit {
  customerId!: string;
  activeTab: number = 0;  
  isEditMode = false;
  editTabIndex: number | null = null;
  customerDetailsForm!: FormGroup;

  billingDetailsForm!: FormGroup;
  shippingDetailsForm!: FormGroup;

  originalCustomerDetails!: any;
  originalBillingDetails!: any;
  originalShippingDetails!: any;

  customer:any = {
    businessName: 'ABC Corp',
    firstName: 'Mike',
    lastName: 'Smith',
    primaryPhone: '5558377587',
    secondaryPhone: '5553492475',
    email: 'smith.mike@gmail.com',
    street: '1234 Main St',
    city: 'Des Moines',
    state: 'IA',
    zip: '54321'
  };

  constructor(private fb: FormBuilder, private route: ActivatedRoute,public confirmationService: ConfirmationService) {}

  ngOnInit() {
    this.customerDetailsForm = this.fb.group({
      businessName: [{ value: '', disabled: true }],
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      primaryPhone: [{ value: '', disabled: true }],
      secondaryPhone: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      street: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      state: [{ value: '', disabled: true }],
      zip: [{ value: '', disabled: true }]
    });
    this.billingDetailsForm = this.fb.group({
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      primaryPhone: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      street: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      state: [{ value: '', disabled: true }],
      zip: [{ value: '', disabled: true }]
    });
    this.shippingDetailsForm = this.fb.group({
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      primaryPhone: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      street: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      state: [{ value: '', disabled: true }],
      zip: [{ value: '', disabled: true }]
    });

    this.customerDetailsForm.patchValue(this.customer);
    this.billingDetailsForm.patchValue(this.customer);
    this.shippingDetailsForm.patchValue(this.customer);

    this.customerDetailsForm.patchValue(this.customer);
    this.billingDetailsForm.patchValue(this.customer);
    this.shippingDetailsForm.patchValue(this.customer);

    // store originals
    this.originalCustomerDetails = this.customerDetailsForm.getRawValue();
    this.originalBillingDetails = this.billingDetailsForm.getRawValue();
    this.originalShippingDetails = this.shippingDetailsForm.getRawValue();
  }

  onEdit(tabIndex: number) {
    this.isEditMode = true;
    this.editTabIndex = tabIndex;

    if (tabIndex === 0) {
      this.originalCustomerDetails = this.customerDetailsForm.getRawValue();
      this.customerDetailsForm.enable();
    } 
    else if (tabIndex === 1) {
      this.originalBillingDetails = this.billingDetailsForm.getRawValue();
      this.billingDetailsForm.enable();
    } 
    else if (tabIndex === 2) {
      this.originalShippingDetails = this.shippingDetailsForm.getRawValue();
      this.shippingDetailsForm.enable();
    }
  }

  onCancel() {
    if (this.editTabIndex === 0) {
      this.customerDetailsForm.reset(this.originalCustomerDetails);
      this.customerDetailsForm.disable();
    } 
    else if (this.editTabIndex === 1) {
      this.billingDetailsForm.reset(this.originalBillingDetails);
      this.billingDetailsForm.disable();
    } 
    else if (this.editTabIndex === 2) {
      this.shippingDetailsForm.reset(this.originalShippingDetails);
      this.shippingDetailsForm.disable();
    }

    this.isEditMode = false;
    this.editTabIndex = null;
  }

  onSave() {
    if (this.editTabIndex === 0) {
      if (!this.customerDetailsForm.dirty) return;
      this.customer = this.customerDetailsForm.getRawValue();
      this.customerDetailsForm.disable();
    } else if (this.editTabIndex === 1) {
      if (!this.billingDetailsForm.dirty) return;
      // Save billing details logic here
      this.billingDetailsForm.disable();
    } else if (this.editTabIndex === 2) {
      if (!this.shippingDetailsForm.dirty) return;
      // Save shipping details logic here
      this.shippingDetailsForm.disable();
    }
    this.isEditMode = false;
    this.editTabIndex = null;
    // TODO: call API here
  }

  onCancelClick() {
    const form = this.getActiveForm();
    console.log('Form dirty state:', form);
    // No changes → cancel immediately
    if (!form || !form.dirty) {
      this.onCancel();
      return;
    }

    // Show confirmation popup
    this.confirmationService.confirm({
      key :'saveConfirm',
      header: 'Save changes?',
      message: 'You have updated information on this page. Do you want to save?',
      
    });
  }

  private getActiveForm(): FormGroup | null {
    if (this.editTabIndex === 0) return this.customerDetailsForm;
    if (this.editTabIndex === 1) return this.billingDetailsForm;
    if (this.editTabIndex === 2) return this.shippingDetailsForm;
    return null;
  }

  private resetAndDisableForm() {
    if (this.editTabIndex === 0) {
      this.customerDetailsForm.reset(this.originalCustomerDetails);
      this.customerDetailsForm.disable();
    }

    if (this.editTabIndex === 1) {
      this.billingDetailsForm.reset(this.originalBillingDetails);
      this.billingDetailsForm.disable();
    }

    if (this.editTabIndex === 2) {
      this.shippingDetailsForm.reset(this.originalShippingDetails);
      this.shippingDetailsForm.disable();
    }

    this.isEditMode = false;
    this.editTabIndex = null;
  }

  onAcceptConfirm() {
    this.confirmationService.close();
    this.onSave();
  }

  onRejectConfirm() {
    this.confirmationService.close();
    this.resetAndDisableForm();
  }
}
